/** @jsx jsx */
import { jsx } from "@emotion/core";

import { useState, useEffect, Fragment } from "react";
import { SiteLink } from "../../components";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { NavBar } from "./navBar";
import { BackButton } from "../backButton/backButton";
import { Hamburger } from "../hamburger/hamburger";
import style from "./topHeaderStyle";
import { NavBarHori } from "./navBarHori";
import { isMax } from "../../lib/css-emotion/breakpoints";

export function TopHeader(props) {
    const [menuOpened, setMenuOpened] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [showNavBarHori, setShowNavBarHori] = useState(true);

  useEffect(() => {
    // inital check
    checkScreenSize();

    // add window size change listener
    window.addEventListener("resize", checkScreenSize);

    // remove window size change listener when component unmount
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setScrolled(offset > 100); // change at 50px
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup listener on unmount
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
    useEffect(() => {
        // inital check
        checkScreenSize();

        // add window size change listener
        window.addEventListener('resize', checkScreenSize);

        // remove window size change listener when component unmount
        return () => {
            window.removeEventListener('resize', checkScreenSize);
        };
    }, []);

    function checkScreenSize() {
        // if screen size is less than 1200px (xl breakpoint), then hide NavBarHori
        setShowNavBarHori(!isMax.xl());
    }

  useScrollPosition(
    ({ prevPos, currPos }) => {
      //console.log(currPos.x)
      //console.log(currPos.y);
      if (currPos.y > 90) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
      //setScrolled(currPos.y > 90)
    },
    [],
    null,
    true
  );
    useScrollPosition(({ prevPos, currPos }) => {
        //console.log(currPos.x)
        //console.log(currPos.y);
        if (currPos.y > 90) {
            setScrolled(true)
        } else {
            setScrolled(false)
        }
        //setScrolled(currPos.y > 90)
    }, [], null, true)

    function toggleMenu(e) {
        setMenuOpened(!menuOpened);
    }

    function onCloseMenu() {
        setMenuOpened(false);
    }

    return (
        <Fragment>
            {/* <header css={[style.top, scrolled && style.topScrolled]} id="top">
        <BackButton/>
        <div css={style.topHeaderContainer} style={{ justifyContent: showNavBarHori ? 'space-between' : 'center'}}>
          <SiteLink to="/" css={[style.logo, scrolled && style.logoScrolled]}>
            <img css={style.logoImg} src="/assets/logos/logo.png" alt="logo" />
          </SiteLink >
          {showNavBarHori && <NavBarHori css={style.navBarHori} />}
        </div>
        <Hamburger opened={menuOpened} toggleMenu={toggleMenu} scrolled={scrolled}/>
        <NavBar open={menuOpened} onCloseMenu={onCloseMenu}></NavBar>
      </header> */}
            <header
                // className={`${scrolled && "scrolled"}`}
                // css={[style.top, scrolled && style.topScrolled]}
                className={``}
                css={[style.top]}
                id='top'
            >
                <div
                    className='top__navi__con__wrap'
                    css={[style.top__navi__con__wrap]}
                >

                    <div className='top__navi__con' css={[style.top__navi__con]}>
                        <NavBarHori
                            open={menuOpened}
                            onCloseMenu={onCloseMenu}
                        ></NavBarHori>
                    </div>

                    <BackButton />
                </div>
                <div
                    className={`mast__head__svg__warpp}`}
                    // css={[
                    //     style.mast__head__svg__warpp,
                    //     scrolled && style.mast__head__svg__warpp__scroll,
                    // ]}
                    css={[
                        style.mast__head__svg__warpp,
                    ]}
                >
                    <div
                        className={`mast__head__svg__con`}
                        css={[
                            style.mast__head__svg__con,
                            // scrolled && style.mast__head__svg__con__scroll,
                        ]}
                    >
                        <div
                            className='top__logo__img'
                            // css={[
                            //     scrolled ? style.top__logo__img__scroll : style.top__logo__img,
                            // ]}
                            css={[
                                style.top__logo__img,
                            ]}
                        >
                            <SiteLink to='/'>
                                <img
                                    // src={scrolled ? '/assets/logos/logo2.png' : '/assets/logos/logo.png'}
                                    src={'/assets/logos/logo.png'}
                                    alt='logo'
                                    width='80%'
                                />
                            </SiteLink>
                        </div>
                    </div>

                    <div
                        className='home__toggle__contents__conv'
                        css={[
                            style.home__toggle__contents__conv,
                            scrolled && style.home__toggle__contents__conv__scoll,
                        ]}
                    >
                        <div
                            style={{ width: "100%", height: "100%", position: "relative" }}
                        >
                            <div
                                className='home__toggle__contents__con'
                                css={[style.home__toggle__contents__con]}
                            >
                                <div
                                    className='home__toggle__contents__item'
                                    style={{ display: "flex" }}
                                    css={style.home__toggle__contents__item}
                                >
                                    {/* <DayNightItem /> */}
                                    <Hamburger
                                        opened={menuOpened}
                                        toggleMenu={toggleMenu}
                                        scrolled={scrolled}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="topbar_hero_img">
          <img
            src="/assets/wooden-pier-picjumbo-com.jpeg"
            alt="hero image"
          ></img>
        </div> */}
                <div className="search_container">
                    {/* <SearchBar onCloseMenu={props.onCloseMenu} /> */}
                </div>
                <NavBar open={menuOpened} onCloseMenu={onCloseMenu}></NavBar>
            </header>
        </Fragment>
    );
}
